module.exports = __webpack_public_path__ + "static/img/s32.be89028.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part1/s32.jpg
// module id = U+1o
// module chunks = 1